import script from "./RandUploads.vue?vue&type=script&setup=true&lang=js"
export * from "./RandUploads.vue?vue&type=script&setup=true&lang=js"

import "./RandUploads.vue?vue&type=style&index=0&id=b2a8ec16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2a8ec16"]])

export default __exports__